import { Card, Form, Input, Modal } from "antd";
import { CustomBtn } from "../../../../components/commonComponents";
import { addFooter, editFooterRequest } from "../actions";
import { useEffect } from "react";

export default function FooterModal({ open, close,  reload, editFooter, setEditFooter }) {

    const [form] = Form.useForm();

    const closeModal = () => {
        form.resetFields();
        close(false);
        if (editFooter) {
            setEditFooter(null);
        }
    }

    useEffect(() => {
        if (editFooter) {
            form.setFieldsValue(editFooter);
        }
    }, [editFooter]);

    const onFinish = (values) => {
        if (editFooter) {
            editFooterRequest(values, editFooter.id).then(res => {
                reload();
                closeModal();
            }).catch(error => {
                console.error(error);
            });
        } else {
            addFooter(values).then(res => {
                reload();
                closeModal();
            }).catch(error => { 
                console.error(error);
            });
        }
    }

    return (
        <Modal
            title="ფუტერის დამატება"
            open={open}
            onCancel={closeModal}
            footer={[
                <CustomBtn type="primary" onClick={form.submit} label={editFooter ? 'რედაქტირება' : 'დამატება'} icon={<i className="fa-solid fa-link"></i>} color={'#1677ff'} htmlType="submit" />,
                <CustomBtn type="secondary" onClick={closeModal} label="დახურვა" icon={<i className="fa-solid fa-xmark"></i>} color={'#f5222d'} colorText={'black'} htmlType="button" />
            ]}
        >
            <Card>
                <Form
                    form={form}
                    onFinish={onFinish}
                    layout="vertical"
                >
                    <Form.Item
                        label="დასახელება"
                        name="label"
                        placeholder="დასახელება"
                        rules={[
                            {
                                required: true,
                                message: 'დასახელება სავალდებულოა'
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item 
                    label={<i className="fa-solid fa-globe"> ბმული</i>} 
                    name="website"
                    rules={[
                        {
                            type: 'url',
                            message: 'ბმულის არასწორი ფორმატი'
                        }
                     ]}
                    >
                        <Input placeholder="https://gcaa.ge" />
                    </Form.Item>
                    <Form.Item 
                    label={<i className="fa-brands fa-facebook" 
                    style={{ fontWeight: 'normal' }}> FB</i>}
                     name="facebook"
                     rules={[
                        {
                            type: 'url',
                            message: 'FB ბმულის არასწორი ფორმატი'
                        }
                     ]}
                     >
                        <Input  placeholder="https://www.facebook.com"/>
                    </Form.Item>
                    <Form.Item 
                    label={<i className="fa-brands fa-instagram" 
                    style={{ fontWeight: 'bold' }}> ინსტაგრამი</i>}
                     name="instagram"
                     rules={[
                        {
                            type: 'url',
                            message: 'ინსტაგრამ ბმულის არასწორი ფორმატი'
                        }
                     ]}
                     >
                        <Input placeholder="https://www.instagram.com/" />
                    </Form.Item>
                </Form>
            </Card>
        </Modal>
    )
}   